import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { Nullable } from "src/app/support/nullable";
import { SkeletonBuilderRow } from "./skeleton-builder-config";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
  selector: "pms-skeleton-builder",
  templateUrl: "skeleton-builder.component.html",
  styles: `
    :host {
      display: flex;
      flex: 1;
    }
  `
})
export class SkeletonBuilderComponent {
  @Input()
  config!: SkeletonBuilderRow;

  getCellTheme(
    actualTheme: Nullable<Record<string, string | number>>
  ): Nullable<Record<string, string | number>> {
    if (!actualTheme) {
      return actualTheme;
    }

    actualTheme["flex"] = actualTheme["flex"] || "1";

    return actualTheme;
  }
}
